import talent from './talent'
import questionnaire from './questionnaire'
import device from './device'

export default [
  ...talent, ...questionnaire, ...device,
]
